<div class="approve-order-dialog-container">
    <div class="approve-order-dialog-header-container">
        <div>  <p class="approve-order-dialog-header-text approve-order-section-headers">APPROVE ORDER?</p></div>
        <div><p class="approve-order-dialog-sub-heading">You are about to approve this order, are you sure?</p></div>
    </div>

    <div class="approve-order-btn-dialog-container">

        <button class="cancel-approve-order-dialog-btn" mat-flat-button type="button" (click)="cancelApproval()">
            <div class="cancel-approve-order-btn-content">
                <span><p class="cancel-approve-order-btn-text">CANCEL</p></span>
            </div>
        </button>

        <button class="approve-order-btn" mat-flat-button type="button"
                (click)="approveOrder()">
            <div class="approve-order-btn-content">
                <span><p class="approve-order-btn-text">APPROVE</p></span>
            </div>
        </button>
    </div>

</div>

